import React from 'react';
import { WorkflowDocumentPicker } from 'src/app/workflows/WorkflowDocumentPicker';
import { ResourceAttachmentDto } from 'src/api/FiretrolApiClient';
import { useChangeDocumentOptions } from 'src/api/queries/changes/useChangeQueries';
import { useAttachChangeDocument } from 'src/api/queries/changes/useChangeMutations';

export interface IChangeDocumentPickerProps {
  jobId: number;
  onAttached: (attachment: ResourceAttachmentDto) => void;
}

export const ChangeDocumentPicker: React.FC<IChangeDocumentPickerProps> = ({
  jobId,
  onAttached,
}) => {
  const { data } = useChangeDocumentOptions(jobId);
  const attach = useAttachChangeDocument();

  return (
    <WorkflowDocumentPicker
      jobId={jobId}
      onAttached={onAttached}
      options={data ?? []}
      attachFromDocument={(id, documentId) =>
        attach.mutateAsync({ jobId: id, documentId })
      }
      attaching={attach.isPending}
    />
  );
};
